export default "__VITE_ASSET__68cc9ccb__"